import React from "react";
import { Header } from "../../Component/Header";
import { Footer } from "../../Component/Footer";
import "./BlogDetails.css";
import Feture from "../../Assest/Images/Blogs/blogbg.png";
import { BLOGCARD, BlgHText } from "../blogs/BlogPage";

const BlogDetails = () => {
  return (
    <>
      <Header />
{/* 
      <section className="BlogSection">
        <div className="Blogwrapper">
          <div className="blogHeading">
            <div class="heading_group">
              <h1 class="bar_heading_dn text-center">OUR BLOS</h1>
            </div>
          </div>

          <div className="TopDetailsBlog">
            <div className="leftdetails">
              <div className="blog_date">
                <h4>May 28, 2024</h4>
              </div>
              <div className="blog_nameshow">
                <a href="#">Grants Program</a>
              </div>
            </div>
            <div className="Rytdetails">
              <span>
                BY <a href="#">LINA SCHROTT</a>
              </span>
              <h1>Gitcoin Grants 20: Results & Recap</h1>
            </div>
          </div>

          <div className="BottomDetailsBlog over">

            <div className="bottomleft">
                <h3>ON THIS PAGE</h3>
                <div className="blogLinks">
                    <a href="#">FUNDING RESULTS</a>
                    <a href="#major-achievements">MAJOR ACHIEVEMENTS</a>
                    <a href="#">RETURN TO ROOTS</a>
                    <a href="#">ROUND STRUCTURE</a>
                    <a href="#">RESULT HIGHLIGHTS</a>
                    <a href="#">RUNNING ROUNDS ON ARBITRUM</a>
                    <a href="#">GITCOIN PASSPORT & SYBIL RESISTANCE</a>
                    <a href="#">IN CONCLUSION</a>
                </div>
            </div>
            <div className="bottomRyt">

                <div className="blogimg">
                    <img src={Feture} alt="Feture"  />
                </div>
                <div class="blog-summary-container">
                    <p class="paragraph margin-0">Gitcoin Grants is a community-driven quarterly funding initiative, aiming to propel high-impact projects forward through the power of Quadratic Funding. Grants = GrowthSince its inception in 2019, Gitcoin Grants has facilitated over 3,500 projects and distributed $60M across 20 rounds, solidifying its position as a Schelling point for seeding and maintaining high impact builders across the ecosystem.&nbsp;GG20, the 20th edition, continued this legacy.</p>
                </div>
                <div class="timeline-connector"></div>

                <div id="major-achievements"><h2>Major Achievements</h2><p><strong>Doubling Down on Open-Source Software and Enhancing Community Governance</strong></p><p>In GG20, we made significant strides in our commitment to open-source software, community governance, protocol upgrades, and sybil resistance, while also enhancing our platform’s features. Here's a recap of the major highlights:</p><div id="doubling-down-on-open-source-software"><h4>Doubling Down on Open-Source Software</h4><p>Reflecting our dedication to open-source software (OSS), we doubled the number of rounds, projects, and matching funds compared to GG19. This substantial increase underscores our commitment to supporting the OSS community and fostering innovation.</p></div><div id="community-rounds-new-governance"><h4>Community Rounds: New Governance</h4><p>For the first time, we introduced community rounds governance, a pivotal move that involved electing a council responsible for allocating matching funds for community-led Quadratic Funding (QF) rounds. This step empowers the community and ensures that the distribution of funds aligns with the collective priorities of our ecosystem. Each of the top 5 communities qualified for an extra $25k in matching from Gitcoin.</p></div><div id="sybil-resistance"><h4>Sybil Resistance</h4><p>To combat sybil attacks, we implemented a two-pronged strategy leveraging COCM (Community-Owned Coin Models) and Passport’s model-based detection system. This dual approach strengthens the integrity of our funding rounds, ensuring that contributions are genuine and that funds are distributed fairly.</p></div><div id="enhanced-features"><h4>Enhanced Features</h4><p>We expanded our collections feature, enabling better organization and curation of projects. The proliferation of side-apps and the consolidation of program rounds on Arbitrum, supported by a partnership with Thrive Coin, further enrich the user experience and streamline our operations.</p></div><div id="protocol-upgrade"><h4>Protocol Upgrade</h4><p>GG20 marked a significant milestone as the first round to operate on our upgraded protocol, transitioning from Allo v1 to Allo v2. This upgrade improves overall user experience, enables experimentation of modular and flexible funding mechanisms, and empowers developers to easily contribute to the protocol to build new community funding experiences.&nbsp;</p><p>These advancements reflect our unwavering commitment to fostering a vibrant, open-source ecosystem and empowering our community through innovative governance and robust technological upgrades. As we move forward, we remain dedicated to continuously improving and adapting to the evolving needs of our community.</p><p>&zwj;</p><blockquote><em>“The transition from Allo v1 to Allo v2&nbsp; makes the protocol much more accessible to other developers. It enables an entire ecosystem to be built around Gitcoin grants rounds, or any customer or partner’s grants rounds. I’m really excited about what we were able to do for GG20 by working so closely with these external builders and the trend that that will set for future grants rounds." </em><br/>Meg, Grants Lab GM</blockquote></div></div>



















            </div>


          </div>



          <div className="BlogsProduct mt-5">

            <BlgHText bklhd="FEATURED POSTS"/>

            <div className="Blgprdt">
                <BLOGCARD Fimg={Feture}/>
                <BLOGCARD Fimg={"https://assets-global.website-files.com/6433e6f821ae13dd37394322/65ddfc65335bc1301f16a879_Allo%20Mainnet%20Blog%20Banner%202.jpg"}/>
                <BLOGCARD Fimg={"https://assets-global.website-files.com/6433e6f821ae13dd37394322/654da7becaf0c4ea94cca5d0_Copy_of_P2.3.png"}/>
                <BLOGCARD Fimg={"https://assets-global.website-files.com/6433e6f821ae13dd37394322/649058e53cf8ea11fa23447d_gsblog.png"}/>
            </div>

          </div>
        </div>
      </section> */}

      <Footer />
    </>
  );
};

export default BlogDetails;
